import React, {useContext} from 'react'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'


export default function ProfileTab({handleOnClick, activeIndex}) {
    const { isDark } = useContext(DarkModeContext);

    return (
        <div className={`profile-lover-header ${isDark ? 'profile-lover-header-dark' : 'profile-lover-header-light'}`}>
            <img onClick={()=>handleOnClick(0)} src={activeIndex == 0 ? require('../../assets/icons/gallery_a.svg'):require('../../assets/icons/gallery.svg')}/>
            <img onClick={()=>handleOnClick(1)} src={activeIndex == 1 ? require('../../assets/icons/camcorder.svg'): require('../../assets/icons/camcorder_grey.svg')}/>
            <img onClick={()=>handleOnClick(2)} src={activeIndex == 2 ? require('../../assets/icons/bookmark_a.svg') : require('../../assets/icons/bookmark.svg')}/>
            <img onClick={()=>handleOnClick(3)} src={activeIndex == 3 ?  require('../../assets/icons/star_a.svg') : require('../../assets/icons/star.svg')}/>
            <img className="profile-tab-url" onClick={()=>handleOnClick(4)} src={activeIndex == 4 ?  require('../../assets/icons/url_a.svg') : require('../../assets/icons/url.svg')}/>

        </div>
    )
}
